module.exports = __webpack_public_path__ + "static/img/dice_4.36cd510.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lottery/dice/dice_4.png
// module id = b7zp
// module chunks = 23